import axios from "axios";

export const Api = {
  Generate: async (animationInput) => { 
    try {
      let bodyContent = JSON.stringify({
        animation: `${animationInput}`
      });

      let headersList = {
        "Accept": "*/*",
        "User-Agent": "https://reanimate.com.br",
        "Content-Type": "application/json" 
       }
      
      let reqOptions = {
        url: "https://rj4wg3aabv2sdtnxyrfco6jfii0cpqjw.lambda-url.sa-east-1.on.aws/api/generate",
        method: "POST",
        headers: headersList,
        data: bodyContent
      };
      
      let response = await axios.request(reqOptions);
      return response.data.animation;
    } catch(error) {
      console.error(error);
      return null; 
  }
},
  Copilot: async (question) => {
    try {
      let headersList = {
       "User-Agent": "Master Motion (https://replicate.reanimate.com.br)",
       "Content-Type": "application/json" 
      }
    
      let reqOptions = {
        url: "https://rj4wg3aabv2sdtnxyrfco6jfii0cpqjw.lambda-url.sa-east-1.on.aws/api/chat/replicate",
        method: "POST",
        headers: headersList,
        data: question,
      }
      
      let response = await axios.request(reqOptions);

      return response.data;
    } catch(error) {
      console.error(error);
      return null; 
  }

  } 

}
